// Navigation Bar SECTION
const navBar = {
  show: true,
};

// ABOUT SECTION
const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../assets/img/Headshot.jpg"),
  message:
    "I'm drawn to hard questions and the places that are difficult to see. That's pulled me through courtrooms in family, criminal, and homeless court, more than a decade building a global ecommerce business, and now into engineering and research. I love every one of these worlds — and the friends and role models I keep finding in them are a big part of why. They've taught me what it means to be at these edges, and how those who live there learn to get where no tools are yet made to take you.\n\nGo on, click on buttons. Tinker. That's what I like to do.",
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Come Build with Me!",
  message: "",
  email: "lizocontactinfo@gmail.com",
};

export { navBar, about, getInTouch };
